/**
 * The mini basket bar: folds into a round button and opens again, and keeps
 * that choice on this device. The bar itself is re-rendered after every cart
 * change, so clicks are caught on this element.
 */
const STORAGE_KEY = 'sda-dock';

class CartDock extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    this.classList.toggle('is-folded', this.#stored === 'folded');

    // Settle the restored state before transitions switch on, so a folded bar
    // doesn't animate shut on every page load.
    void this.firstElementChild?.offsetWidth;
    this.toggleAttribute('data-ready', true);

    this.addEventListener('click', (event) => event.target.closest('[data-dock-toggle]') && this.#toggle(), {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  get #stored() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  }

  #toggle() {
    const folded = this.classList.toggle('is-folded');

    try {
      localStorage.setItem(STORAGE_KEY, folded ? 'folded' : 'open');
    } catch {
      // Private browsing: the choice lasts for this page only.
    }

    this.querySelector(folded ? '.sda-dock__open' : '.sda-dock__fold')?.focus();
  }
}

if (!customElements.get('cart-dock')) customElements.define('cart-dock', CartDock);
